<template>
<div>
    <div class="cover cover--small" :style="'background-image: url(' + require('@/assets/cover-platform.jpg') + ')'">
        <h1 class="cover__title">Platform</h1>
    </div>
    <div class="white-box wrapper wrapper--spaced wrapper--centered">
        <h1 class="title">A Common Sense Plan for<br>all British Columbians</h1>
        <p class="text">See where Aaron stands on many of the most important issues facing British Columbia. </p>
        <p class="text text--bold">More coming soon.</p>
    </div>

    <div class="white-box">
        <div class="wrapper wrapper--spaced-bottom wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/money-bag.svg"/>Cost of Living</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>End the ICBC Monopoly</h2>
                        <p class="text">ICBC is a bloated, ineffective government monopoly that charges some of the highest rates in the entire country. It’s time to allow choice and competition so that British Columbians can shop around for the price and plan that’s right for them.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Get Gas Prices Under Control	</h2>
                        <p class="text">British Columbians are getting screwed at the pumps. With the highest gas prices in North America, it’s time to axe the Carbon Tax, the Low Carbon Fuel Standard and ensure more refined product reaches the B.C. market. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Stabilize the Housing Market</h2>
                        <p class="text">Encourage a stable and predictable housing market. This means getting prices under control by promoting the development of new housing supply while cracking down on illegal money laundering that has inflated prices and facilitated criminal activity.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">4</div>Emergency Housing Supply</h2>
                        <p class="text">Introduce special “density zones” that allow the Provincial Government to supersede local councils and streamline the production of new housing units where they are needed most. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">5</div>Choice in Child Care</h2>
                        <p class="text">Support all new parents with the costs of childcare directly, while incentivizing the private sector to create new childcare spaces. This plan includes forming partnerships with municipalities. </p>
                    </li>
                    <li class="policy__item"></li>
                </ul>
            </div>
        </div>
    </div>

    <div class="grey-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/growth.svg"/>The Economy</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Lower Taxes, Smaller Government</h2>
                        <p class="text">The government is an inefficient delivery vehicle for services and its growth is cannibalizing private-sector job creation. Wasteful spending should be cut and the savings returned to taxpayers.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Balance the Budget</h2>
                        <p class="text">It is immoral (and financially hazardous) to continue living beyond our means and leaving our children with the bill. Within 24 months, the budget must be balanced.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Champion Small Business</h2>
                        <p class="text">Small and medium-sized businesses are the backbone of our economy and the bedrock of our communities. Useless and redundant regulations need to be removed, while larger corporations need to be held accountable if they engage in unfair or anti-competitive practices.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">4</div>Get B.C. Back to Work</h2>
                        <p class="text">Paying individuals “not to work” may have been a temporary necessity at the outbreak of COVID-19, but it is now contributing to a chronic labour shortage across the province. It’s time to get British Columbians back to work.</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="white-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/gasoline-pump.svg"/>Energy &amp; the Environment</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Scrap the Carbon Tax</h2>
                        <p class="text">The regressive, job-killing carbon tax drives up the cost of living and has no impact on global emissions. It is unfair to rural and northern communities and leads to the offshoring of jobs overseas.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Expand LNG</h2>
                        <p class="text">Dramatically expand B.C.’s natural gas production and LNG export facilities and reduce global emissions through the displacement of coal-fired electricity in countries like China. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Get Pipelines Built</h2>
                        <p class="text">Pipelines are the safest and most economical means of transporting oil and natural gas and are essential in getting our resources to market. Their construction, including TMX, Coastal GasLink and Northern Gateway, deserve our complete support. </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="grey-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/sprout.svg"/>Forestry, Mining and B.C.’s Resource Industries</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Support B.C. Forestry</h2>
                        <p class="text">B.C.’s forest industry is the envy of the world. It is 100% sustainable and renewable and supports tens of thousands of high-paying jobs across the province.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Hold Activists Accountable</h2>
                        <p class="text">Activists who impede the activity of resource development through illegal blockades, harassment and violence must be held legally, and financially, responsible for their actions – as must the groups that support them. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Encourage Mining, Hydro-electricity, Fishing, and More!</h2>
                        <p class="text">British Columbia is a resource superpower. Encourage and promote the development of these resources in a way that is sustainable, and that delivers maximum value to the taxpayers of our province. </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="white-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/book.svg"/>Education</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Support Parents’ Choices</h2>
                        <p class="text">Parents have the right to determine how and where their children will be educated. Government must provide fair and reasonable funding to families for the type of education they choose for their children. This includes public, private or homeschooling.  </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Remove Ideology from the Classroom</h2>
                        <p class="text">Political bias and ideology have no place in B.C.’s education curriculum and must be removed immediately. Schools must be places of learning – not tools for activism and indoctrination. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Protect Free Speech on Campus</h2>
                        <p class="text">Universities and colleges that do not support and defend freedom of expression on campus will be defunded. Taxpayer money will not be used to support places of censorship and intimidation. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">4</div>Post-Secondary Funding Re-Allocation </h2>
                        <p class="text">Government funding within post-secondary institutions will be re-allocated to promote and incentivize training in essential fields such as medicine, engineering, and skilled trades.</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="grey-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/stethoscope.svg"/>Health Care</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Serious, Substantive Reform</h2>
                        <p class="text">The performance of British Columbia’s health care system throughout the COVID-19 pandemic has been abysmal. Chronic shortages in physicians, nurses and ICU capacity has become painstakingly clear. It’s time for serious reform. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Choice and Competition</h2>
                        <p class="text">Allow choice and competition in the delivery of health care services while retaining universal access for all British Columbians. End the government's court case against private clinics and unleash the power of private-sector innovation.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Reduce Wait Times</h2>
                        <p class="text">Unless we embrace bold reforms, British Columbians will continue to suffer with unreasonable delays on many medical procedures. Reform hospital funding to incentivize output - just like many European countries (and Australia) have done to improve results.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">4</div>More Doctors, More Nurses</h2>
                        <p class="text">Incentivize post-secondary institutions to train more RNs, LPNs, and physicians by prioritizing government funding and support for these programs and students.   </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="white-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/hospital.svg"/>Mental Illness, Homelessness and the B.C. Opioid Crisis</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Re-Open Mental Hospitals</h2>
                        <p class="text">Re-open and revitalize mental hospitals and facilities to give suffering British Columbians the help that they deserve. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>End Heroin Hand-Outs</h2>
                        <p class="text">Handing out heroin and other hard drugs to addicts does not solve the problem and instead perpetuates a coercive and destructive addiction. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Stop Warehousing Addicts</h2>
                        <p class="text">Taxpayer money should not be used to purchase hotels in residential areas and warehouse those addicted to drugs. These programs don’t work, crater property values and increase crime in the community. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">4</div>Mandatory Rehabilitation </h2>
                        <p class="text">Instead of “destigmatizing” hard drug use, it’s time to acknowledge the serious harm it causes to users, their families and the communities around them. Through mandatory rehabilitation, addicts will be offered an opportunity to get clean and become productive, taxpaying members of society once again. </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="grey-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/handcuffs.svg"/>Crime and Lawlessness</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Defend the Police</h2>
                        <p class="text">Instead of defunding the police, our brave men and women in law enforcement should be supported and given the resources they need to successfully do their jobs.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Crack Down on Violent Crime</h2>
                        <p class="text">Zero tolerance for violent and repeat offenders. End the revolving door justice system by directing prosecutors to pursue maximum sentencing for those convicted of serious crimes. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Appoint principled Judges</h2>
                        <p class="text">Appoint judges that put victims and their families first – not the sob stories of hardened criminals. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">4</div>No More “Tent Cities”</h2>
                        <p class="text">Illegal “tent cities” lead to increases in crime, violence and disorder in otherwise peaceful communities. They are unfair to those who work hard, pay their taxes, follow the law and have had their neighborhoods stolen from them. </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="white-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/witness.svg"/>Culture and Freedom</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>End Vaccine Mandates and Passports</h2>
                        <p class="text">While medically-approved inoculation should be encouraged, and vaccines offered to all British Columbians, individuals should not be mandated or coerced into receiving any medical treatment (including vaccination) against their will – and common sense exemptions (natural immunity, medical necessity etc.) should be recognized immediately. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>Defend Our History</h2>
                        <p class="text">British Columbia’s (and Canada’s) history is not perfect – but nothing (or no one) ever is. We should be proud of the province we call home and the generations who came before us. Historical markers of that past legacy, including statues, must be protected and, where needed, restored. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Oppose Identity Politics</h2>
                        <p class="text">Identity politics is a divisive ideological force that must be rejected. British Columbians should be treated equally regardless of their race, gender, religion or sexual orientation. Programs that discriminate based on these characteristics must be disbanded. </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="grey-box">
        <div class="wrapper wrapper--spaced wrapper--centered">
            <div class="policy">
                <h1 class="title policy__title"><img src="@/assets/policies-icons/flag.svg"/>BC Liberal Party</h1>
                <ul class="policy__list">
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">1</div>Change the Party Name</h2>
                        <p class="text">The “BC Liberal” name is confusing, unrepresentative of the party membership and needs to be changed.</p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">2</div>MLA Autonomy</h2>
                        <p class="text">Each individual MLA should be encouraged to cultivate their own identity and speak out on issues important to themselves and their constituents. Stronger MLAs will lead to a stronger team, a stronger party and a stronger showing in the next election. </p>
                    </li>
                    <li class="policy__item">
                        <h2 class="title title--small policy__name"><div class="policy__number">3</div>Empower Party Members</h2>
                        <p class="text">The party should refrain (in any but the most exceptional circumstances) from appointing candidates without first holding a competitive nomination process. </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import facebookMixin from '@/videos-mixin.js'
export default {
    mixins: [facebookMixin],
    created () {

    },
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
.policy { text-align: left; }
.policy__title { display: flex; flex-direction: column; align-items: center; text-align: center; }
.policy__title::after { content: " "; background: #E0231C; height: 5px; width: 100px; margin-top: 20px; }
.policy__title img { max-height: 70px; padding-bottom: 20px; }
.policy__list { list-style: none; display: flex; flex-wrap: wrap; margin-top: 60px; justify-content: space-between; }
.policy__item { width: calc(90% / 3); margin-bottom: 40px; }
.policy__name { display: flex; margin-bottom: 20px; }
.policy__number { min-width: 40px; height: 40px; color: white; background: #E0231C; display: flex; align-items: center; justify-content: center; margin-right: 20px; }


@media (max-width: 1100px) {
    .policy__item { width: 100%; margin-left: 0; margin-bottom: 40px; }
    .policy__name { align-items: center; }
}

</style>
